<template>
  <modal name="modalSearchParticipant" class="custom-modal add-participant-modal" :width='"605px"' :height="'auto'"
         :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose" :clickToClose="false">
    <div class="modal-padding">
      <div class="modal-close-img" @click="hideModal()">
        <div class="icon-close"></div>
      </div>
      <div class="title">add participant</div>
      <div class="participant-info">
        <div class="row">
          <div class="col-md-6">
            <div class="title-field">Search for existing participant</div>
          </div>
          <div class="col-md-6">
            <div class="checkbox-container">
              <b-form-checkbox v-if="!fromBiometric" v-model="slot.hasBiometric" class="ap-checkbox-group add-more-services-checkbox">Add biometric screening</b-form-checkbox>
              <b-form-checkbox v-else-if="fromBiometric && eventDetail.eventSlotGroupsFLuShotOnly.length > 0" v-model="slot.hasFluShot" class="ap-checkbox-group add-more-services-checkbox">
                <template v-if="fluShot == 1">Add flu shot</template>
                <template v-else-if="fluShot == 2">Add Covid Vaccine</template>
                <template v-else>Add Covid & Flu Shot</template>
              </b-form-checkbox>
              <span v-else></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <input class="placeholder-italic" v-model="searchText" placeholder="Search by first name, last name or email" />
            <div class="search-icon"></div>
          </div>
        </div>
      </div>
      <div class="spinner-loading" v-if="getIsLoadingParticipant === loadingConstants.LOADING">
        <Spinner></Spinner>
      </div>
      <div v-else="">
        <div v-if="filledSlots.length > 0">
          <div class="employee-list-container">
            <div class="list-header">
              <div class="row">
                <div class="col-md-3">
                  <HeaderColumn :headerObject="arrHeaderObj[0]" :sortObject="sortObject" @CHANGE_SORT_OPTION="handleChangeSortOption"></HeaderColumn>
                </div>
                <div class="col-md-4">
                  <HeaderColumn :headerObject="arrHeaderObj[1]" :sortObject="sortObject" @CHANGE_SORT_OPTION="handleChangeSortOption"></HeaderColumn>
                </div>
                <div class="col-md-3">
                  <HeaderColumn :headerObject="arrHeaderObj[2]" :sortObject="sortObject" @CHANGE_SORT_OPTION="handleChangeSortOption"></HeaderColumn>
                </div>
                <div class="col-md-2">
                  <div class="field-col">
                    <div class="caption-text label-text"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-participant-row">
              <div>
                <template v-for="(p, index) in filledSlots">
                  <ParticipantTableInfo :requestUpdateTable="requestUpdateTable" :eventId="eventId" :slot="slot" :participant="p" :key="index" :fluShot="fluShot"></ParticipantTableInfo>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-add-container" v-if="isShowingText && searchText && getIsLoadingParticipant === loadingConstants.LOADED">
        <div v-if="isEnableButton" class="display-text">
          <div v-if="!isFoundParticipant">
            "{{searchText}}" could not be found.<br/>
            You can create and add a participant to the slot.
          </div>
          <div v-else class="display-text">
            If the participant you are looking for is not listed.<br/>
            You can create and add a new participant.
          </div>
          <div class="margin-top-24px">
            <button class="ap-btn primary btn-add-participant" @click="addNewParticipant()">Create & Add Participant</button>
          </div>
        </div>
        <div v-else class="display-text">
          "{{searchText}}" could not be found.<br/>
          Please contact your HR representative to add the participant.
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
  import HeaderColumn from '../../../components/commons/HeaderColumn.vue';
  import ParticipantTableInfo from './ParticipantTableInfo.vue';
  import loadingConstants from '../../../store/loading-constants';
  import Spinner from '../../../components/commons/Spinner.vue';
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  const _ = require('lodash');
  // import constant from '../../_consts';

  export default {
    name: 'modalSearchParticipant',
    components: {
      Icon,
      HeaderColumn,
      ParticipantTableInfo,
      Spinner
    },
    props: {
      requestUpdateTable: {
        type: Function
      }
    },
    data () {
      return {
        eventDetail: {},
        eventId: 0,
        participant: {},
        searchText: '',
        slot: {},
        loadingConstants: loadingConstants,
        arrHeaderObj: [
          {
            internalName: 'fullName',
            displayName: 'NAME'
          },
          {
            internalName: 'email',
            displayName: 'EMAIL'
          },
          {
            internalName: 'employeeId',
            displayName: 'EMPLOYEE ID'
          }
        ],
        sortObject: {
          fieldName: '',
          reverse: false
        },
        filledSlots: [],
        isEnableButton: false,
        isShowingText: false,
        isFoundParticipant: false,
        fromBiometric: false,
        fluShot: 0
      }
    },
    methods: {
      hideModal () {
        this.searchText = '';
        this.isFoundParticipant = false;
        this.filledSlots = [];
        this.$modal.hide('modalSearchParticipant');
      },
      beforeOpen (obj) {
        this.eventDetail = obj.params.eventDetail;
        this.eventId = obj.params.eventId;
        this.slot = obj.params.participant;
        this.fromBiometric = this.slot.fromBiometric;
        this.slot.hasFluShot = 0;
        this.slot.hasBiometric = false;
        this.isEnableButton = localStorage.getItem('IS_ADDED_PARTICIPANT');
        this.fluShot = obj.params.fluShot;
      },
      beforeClose () {
      },
      getParticipant (keyword) {
        let params = {
          params: {
            eventId: this.eventId,
            searchString: keyword && keyword.length >= 0 ? keyword : this.searchText
          }
        };
        this.searchParticipant(params).then(response => {
          this.isShowingText = true;
          if (response && (response.statusCode === 'BAD_REQUEST' || response.statusCode === 'NOT_FOUND')) { // return if there is message found
            this.isFoundParticipant = false;
            this.filledSlots = [];
            return;
          }
          this.isFoundParticipant = true;
          response.filledSlots.forEach(el => {
            el.fullName = el.firstName + ' ' + el.lastName;
          });
          this.filledSlots = response.filledSlots;
          // this.resetSortObject();
        }).catch(error => {
          console.log('error=', error);
        });
      },
      addNewParticipant () {
        this.searchText = '';
        this.isFoundParticipant = false;
        this.filledSlots = [];
        this.$modal.hide('modalSearchParticipant');
        let body = {
          eventId: this.eventId,
          slot: {
            ...this.slot,
            hasFluShot: this.slot.hasFluShot ? this.fluShot : 0
          },
          eventDetail: this.eventDetail
        };
        this.$modal.show('modalAddParticipant', body);
      },
      resetSortObject () {
        this.sortObject = {
          fieldName: '',
          reverse: false
        };
      },
      ...mapActions({
        addParticipant: 'ACTION_ADD_PARTICIPANT',
        searchParticipant: 'ACTION_SEARCH_PARTICIPANT'
      }),
      ...mapMutations({
      })
    },
    computed: {
      ...mapGetters({
        getIsLoadingParticipant: 'GETTER_IS_LOADING_PARTICIPANT'
      })
    },
    watch: {
      searchText: _.debounce(function () {
        let keyword = this.searchText.trim();
        if (keyword.length >= 2 || keyword.length === 0) {
          this.getParticipant(keyword);
        }
      }, 700)
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';

  .custom-modal {
    .modal-padding {
      padding: 26px 24px 30px 24px;
      .modal-close-img {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        .icon-close {
          margin: 1.5px 1.5px;
          width: 27px;
          height: 27px;
          color: @grey-3;
          background-color: @grey-3;
          -webkit-mask: url('../../../../static/img/action-close.svg') no-repeat center;
          mask: url('../../../../static/img/action-close.svg') no-repeat center;
          background: url('../../../../static/img/action-close-grey.svg');
        }
      }
      .first-name-and-last-name-text-box {
        height: 48px;
        width: 266px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .email-text-box {
        height: 48px;
        width: 369px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .employee-text-box {
        height: 48px;
        width: 162px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .title {
        color: @black-3;
        font-family: @font-family-main;
        font-size: 32px;
        font-weight: 800;
        letter-spacing: -1px;
        line-height: 40px;
        text-transform: uppercase;
        margin-bottom: 20px;
      }
      .text {
        color: @grey-8;
        font-family: @font-family-main;
        font-size: 16px;
        line-height: 24px;
        height: 45px;
      }
      .placeholder-italic {
        width: 100%;
        border: 1px solid @grey-6;
        padding: 3px 15px;
        font-family: 'Open Sans', sans-serif;
        height: 42px;
        border-radius: 3px;
        background-color: @white;
      }
      .search-icon {
        width: 26px;
        height: 26px;
        color: @light-blue;
        background-color: @light-blue;
        position: absolute;
        z-index: 999;
        right: 26px;
        top: 9px;
        -webkit-mask: url('../../../../static/img/search.svg') no-repeat center;
        mask: url('../../../../static/img/search.svg') no-repeat center;
        background: url('../../../../static/img/search-blue.svg');
      }
      .btn-add-container {
        display: flex;
        justify-content: center;
      }
      .btn-add-participant {
        text-transform: uppercase;
      }
      .display-text {
        display: flex;
        text-align: center;
        flex-direction: column;
      }
    }
    .employee-list-container{
      padding-top: 24px;
      padding-bottom: 40px;
      margin-left: -16px;
      margin-right: -16px;

      .list-header{
        padding: 16px;
        border-bottom: 1px solid #E6E6E6;

        .field-col{
          display: flex;

          .caption-text{
            color: #D92C27;
            font-weight: bold;
            letter-spacing: 0.1px;
          }

          .sort-icon{
            margin-top: 8px;
          }
        }
      }

      .list-participant-row{

        .not-found-participant-checked-in{
          color: #1D1D1D;
          margin-left: 16px;

          .search-text{
            font-weight: bold;
          }
        }
      }
    }
    .spinner-loading {
      padding-top: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// SearchParticipantModal.vue?1edee282